import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const EnergyPlugGlyph = /*#__PURE__*/createElement("g", {
  transform: "translate(0.000000,71.000000) scale(0.100000,-0.100000)",
  stroke: "none"
}, /*#__PURE__*/createElement("path", {
  d: "M279 667 c-126 -36 -212 -127 -240 -255 -28 -124 -25 -154 23 -207 38 -44 93 -73 154 -82 l46 -6 -21 38 c-17 33 -19 49 -14 116 6 77 5 78 -25 108 -21 21 -40 31 -61 31 l-31 0 0 -77 c-1 -84 -11 -84 -30 2 -17 77 8 146 79 216 117 115 271 120 390 13 86 -77 117 -183 86 -289 -31 -108 -154 -205 -260 -205 l-34 0 19 44 c17 40 17 45 3 50 -20 8 -18 11 -47 -56 -32 -72 -22 -83 64 -75 118 10 218 77 270 179 26 53 30 72 30 142 0 92 -18 143 -76 212 -69 85 -218 131 -325 101z"
}), /*#__PURE__*/createElement("path", {
  d: "M353 418 c-10 -13 -63 -178 -63 -196 0 -9 130 -72 150 -72 16 0 123 168 117 183 -5 12 -168 97 -187 97 -4 0 -12 -6 -17 -12z"
}));
const EnergyPlug = createSvg({
  name: 'energy_plug',
  path: EnergyPlugGlyph
});

export default EnergyPlug;
export { EnergyPlugGlyph };
